import { LoadingOptions } from '@ionic/core';

export const SPINNER_IMAGE = '<img src="assets/heart.svg">';

export default function spinnerOptions(text: string = ''): LoadingOptions {
  return {
    spinner: null,
    cssClass: 'heart-spinner',
    message: text,
    animated: true,
  };
}
